import React, { useContext } from "react";
// import {Link} from "react-router-dom";
// import { texts } from "../Components/LoginComponent/texts";
import GeneralPage from "../GeneralPage";
import rhino from '../assets/images/rhino.png'
import shark from '../assets/images/shark.png'
import gorilla from '../assets/images/gorilla.png'
import eagle from '../assets/images/eagle.png'
import tiger from '../assets/images/tiger.png'
import rhinow from '../assets/images/rhino.webp'
import sharkw from '../assets/images/shark.webp'
import gorillaw from '../assets/images/gorilla.webp'
import eaglew from '../assets/images/eagle.webp'
import tigerw from '../assets/images/tiger.webp'

import artist from '../assets/images/artist.png'
import genius from '../assets/images/genius.png'
import queen from '../assets/images/queen.png'
import professor from '../assets/images/professor.png'
import poet from '../assets/images/poet.png'
import UserContext from "../Contexts/User";
import AppContext from "../Contexts/AppContext";
import { Buttons } from "../Components/Atoms/Button/Button";
import { texts } from "../Components/LoginComponent/texts";
// @ts-ignore
import marketingVideo from '../assets/images/marketing_video.mp4';
import previewImage from '../assets/images/VideoPreiew.png';


const About = () => {
  const { user } = useContext(UserContext);
  const { setLogin, setSignup } = useContext(AppContext);
  return (
    <GeneralPage>
      <div >
        {/* <h1>{(`${texts.AboutCoinParliament}`).toUpperCase()}</h1> */}
        <div>
          <h1 style={{ textAlign: 'center' }} className="page-title">Hey there and welcome to Anime Parliament!</h1>
          <p style={{ textAlign: 'justify' }} >We're the most exciting web 3-based Vote To Earn game out there, and we're thrilled to offer you a unique opportunity to make your voice heard while earning rewards at the same time.</p>
          <p style={{ textAlign: 'justify' }}>
            At Anime Parliament, we're not just a game; we're a community of crypto enthusiasts and collectors. Our platform combines the excitement of crypto with the thrill of card collecting and the potential for substantial rewards.
            We're delighted to have you join our growing community at Anime Parliament. Here, you'll discover a world of crypto-driven excitement, where your votes, card collections, and strategic upgrades unlock a universe of opportunities.
            From unique cards to Collectibles, influencer levels to lifetime royalties, your journey with us promises adventure and prosperity. We're here to support you every step of the way.
          </p>

        </div>


        {/* <div className="video-container">
          <video controls poster={previewImage}>
            <source src={marketingVideo} type="video/mp4" />
          </video>
        </div> */}

        <h5 style={{ textAlign: 'center' }} className="page-title pt-4">The Team </h5>

        {/* Card Rhino */}

        <div className="row">
          <div className="col-md-6 mb-5">
            <h6 className="mb-6 sub-title">The Artist</h6>
            <p>A vibrant force of passion, color, and truth. The Artist leads with emotion and never shies away from saying what needs to be said. She believes every vote is a brushstroke on the canvas of culture. With her creative fire and unapologetic voice, she turns opinions into art and rallies the community to express themselves boldly.  </p>
            <p className="mb-0"><strong>Known for </strong> The Rebel Heart  </p>
            <p className="mb-0"><strong>Occupation </strong> Visionary, Cultural Creator </p>
            <p className="mb-0"><strong>Hobbies </strong> Painting, Protesting, Spicy Debates</p>
          </div>
          <div className="col-md-6 mb-5">
            <div className="text-center">
              <picture className="about-pic-bg ms-md-auto">
                {/* <source type="image/webp" srcSet={rhinow} width={window.screen.width > 767 ? "250px" : "170px"} />
                <source type="image/jpeg" srcSet={rhino} width={window.screen.width > 767 ? "250px" : "170px"} /> */}
                <img src={artist} alt="" width={window.screen.width > 767 ? "200px" : "200px"} />
              </picture>              
            </div>
          </div>


        </div>


        {/* card eagle  */}

        <div className="row">
          <div className="col-md-6 mb-5">
            <h6 className="mb-6 sub-title">The Genius</h6>
            <p>If logic had a heartbeat, it would sound like him. The Genius brings structure to the chaos, dropping truth bombs and calculations in equal measure. He loves the sound of facts and the thrill of winning with reason. When he votes, it’s not a guess — it’s a formula for impact. </p>
            <p className="mb-0"><strong>Known for </strong> The Formula</p>
            <p className="mb-0"><strong>Occupation </strong> Thinker, Mathematician of Democracy</p>
            <p className="mb-0"><strong>Hobbies </strong>Solving, Tinkering, Classical Music</p>
          </div>
          <div className="col-md-6 mb-5">
            <div className="text-center">
              <picture className="about-pic-bg ms-md-auto">
                {/* <source type="image/webp" srcSet={eaglew} width={window.screen.width > 767 ? "300px" : "250px"} />
                <source type="image/jpeg" srcSet={eagle} width={window.screen.width > 767 ? "300px" : "250px"} /> */}
                <img src={genius} alt="" width={window.screen.width > 767 ? "200px" : "200px"} />
              </picture>              
            </div>
          </div>
        </div>


        {/* card Queen */}

        <div className="row">
          <div className="col-md-6 mb-5">
            <h6 className="mb-6 sub-title">The Queen</h6>
            <p>Commanding yet graceful, The Queen speaks softly but moves mountains. Her strategy is silent power. Her votes are royal decrees. She’s the one who reminds the Parliament that elegance and influence are not mutually exclusive — they’re her superpower.</p>
            <p className="mb-0"><strong>Known for </strong>The Crown Call</p>
            <p className="mb-0"><strong>Occupation </strong> Diplomat, Powerhouse </p>
            <p className="mb-0"><strong>Hobbies </strong> Jewelry, Legacy, Secret Alliances  </p>
          </div>
          <div className="col-md-6 mb-5">
            <div className="text-center">
              <picture className="about-pic-bg ms-md-auto">
                {/* <source type="image/webp" srcSet={tigerw} width={window.screen.width > 767 ? "220px" : "150px"} />
                <source type="image/jpeg" srcSet={tiger} width={window.screen.width > 767 ? "220px" : "150px"} /> */}
                <img src={queen} alt="" width={window.screen.width > 767 ? "200px" : "200px"} />
              </picture>              
            </div>
          </div>
        </div>

        {/* card Professor  */}

        <div className="row">
          <div className="col-md-6 mb-5">
            <h6 className="mb-6 sub-title">The Professor </h6>
            <p>Curious, eccentric, and brilliant — The Professor thrives on turning questions into revolutions. With wild hair and wilder ideas, he breaks down complex truths so anyone can understand. He’s the people’s brain, constantly reminding the Parliament that knowledge is the ultimate vote multiplier.  </p>
            <p className="mb-0"><strong>Known for </strong>The Brainwave</p>
            <p className="mb-0"><strong>Occupation </strong>Teacher of Truths</p>
            <p className="mb-0"><strong>Hobbies </strong>Chalk Dust, Quantum Theories, Voting Systems</p>
          </div>
          <div className="col-md-6 mb-5">
            <div className="text-center">
              <picture className="about-pic-bg ms-md-auto">
                {/* <source type="image/webp" srcSet={gorillaw} width={window.screen.width > 767 ? "250px" : "200px"} />
                <source type="image/jpeg" srcSet={gorilla} width={window.screen.width > 767 ? "250px" : "200px"} /> */}
                <img src={professor} alt="" width={window.screen.width > 767 ? "200px" : "200px"} />
              </picture>           
            </div>
          </div>
        </div>

        {/* card shark */}

        <div className="row">
          <div className="col-md-6 mb-5">
            <h6 className="mb-6 sub-title">The Poet </h6>
            <p>Where others see polls, he sees poetry. The Poet believes every vote has a soul, and every opinion is a verse. With charm, wit, and a flair for drama, he turns even the most casual debates into performances that leave the crowd wanting more. </p>
            <p className="mb-0"><strong>Known for </strong>The Wordsmith</p>
            <p className="mb-0"><strong>Occupation </strong>Storyteller, Crowd Charmer </p>
            <p className="mb-0"><strong>Hobbies </strong> Theater, Late-Night Rants, Smooth Speeches</p>
          </div>
          <div className="col-md-6 mb-5">
            <div className="text-center">
              <picture className="about-pic-bg ms-md-auto">
                {/* <source type="image/webp" srcSet={sharkw} width={window.screen.width > 767 ? "300px" : "250px"} />
                <source type="image/jpeg" srcSet={shark} width={window.screen.width > 767 ? "300px" : "250px"} /> */}
                <img src={poet} alt="" width={window.screen.width > 767 ? "200px" : "200px"} />
              </picture>            
            </div>
          </div>
        </div>

        {!user?.uid && window.screen.width > 979 && <div className='d-sx-none'> <Buttons.Primary style={{ margin: 'auto', marginTop: '4rem', fontSize: '2rem', padding: '2rem' }} onClick={e => {
          setLogin(true)
          setSignup(true)
        }}>{texts.signUp}</Buttons.Primary></div>}



        {!user?.uid && window.screen.width < 979 && <div className='d-xl-none'><Buttons.Primary style={{ margin: 'auto', marginTop: '2rem', fontSize: '1rem', padding: '1rem' }} onClick={e => {
          setLogin(true)
          setSignup(true)
        }}>{texts.signUp}</Buttons.Primary>
        </div>}

      </div>
    </GeneralPage>
  );
};

export default About;
